import axios from "axios";
import React, { useEffect, useState } from "react";

const ModifyVoucher = ({ modifyVoucherNo }) => {
  const COMPANY_CODE = localStorage.getItem("companyCode");
  const [entries, setEntries] = useState([]);
  // const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  useEffect(() => {
    console.log("🚀 ~ ModifyVoucher ~ modifyVoucherNo:", modifyVoucherNo);
    fetchModifyVNoData(modifyVoucherNo);
  }, []);

  const fetchModifyVNoData = async (modifyVoucherNo) => {


    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiURL = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocTransfer/${COMPANY_CODE}/VOUCHERMODIFY/RV-C/-/-/${currentSelectedDepartment}/${modifyVoucherNo}/-`;

    try {
      const response = await axios.get(apiURL);
      const data = response.data;
      console.log("🚀 ~ fetchModifyVNoData ~ data:", data);
      setEntries(data);
    } catch (error) {
      console.error("🚀 ~ fetchModifyVNoData ~ error:", error);
    }
  };

  return (
    <div className="mx-4 mt-6 border rounded bg-white overflow-x-auto overflow-y-auto h-[30vh] ">
      <table className="min-w-full border-collapse text-sm max-h-600">
        <thead className="bg-gray-100 sticky top-0 z-20">
          <tr className="min-h-12">
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
              SL No.
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
              Account
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
              Account Name
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
              Reference
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[240px]">
              Type / TY
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[140px]">
              Amount
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
              Cur No / Cur
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              Rate
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              FC Amount / curamount
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
              Chq No.
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              Chq Date
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              Bank
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              PDC Acc
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
              Job Code
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              C Center / ccno
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              Cost Code
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              TRN
            </th>
            <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
              VAT amt
            </th>
          </tr>
        </thead>

        <tbody>
          {entries?.length > 0 ? (
            entries.map((row, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="border px-2 py-1 text-center">{index + 1}</td>
                <td className="border px-2 py-1">{row.account || ""}</td>
                <td className="border px-2 py-1">{row.accdesc || ""}</td>
                <td className="border px-2 py-1 text-center">
                  {row.ref || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.type || ""}
                </td>
                <td className="border px-2 py-1 text-right">
                  {row.amount || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.curno || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.rate || ""}
                </td>
                <td className="border px-2 py-1 text-right">
                  {row.curamount || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.chqno || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.chqdate
                    ? new Date(row.chqdate).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                    : ""}
                </td>

                <td className="border px-2 py-1 text-center">
                  {row.bank || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.pdc_acc || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.job_code || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.ccno || ""}
                </td>
                <td className="border px-2 py-1 text-center">
                  {row.COSTCODE || ""}
                </td>
                <td className="border px-2 py-1 text-right">
                  {row.ttref || ""}
                </td>
                <td className="border px-2 py-1 text-right">
                  {row.v_amt || ""}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="16" className="text-center py-4 text-gray-500">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ModifyVoucher;
